import { orderBy, reverse } from "lodash";

import DumbbellPlot from "@/classes/DumbbellPlot";
import DumbbellPlotHorizontal from "@/classes/DumbbellPlotHorizontal";
import Lang from "@/lang";
import { ChartDataRecord } from "@/types/charts";

export const mapDataDumbbell = (
  data: ChartDataRecord[],
  chart: DumbbellPlot | DumbbellPlotHorizontal,
  isReverse = false
): ChartDataRecord[] => {
  chart.maxField = `${chart.settings.displayMetric}_max`;
  chart.medianField = `${chart.settings.displayMetric}_median`;
  chart.minField = `${chart.settings.displayMetric}_min`;

  chart.min = null;
  chart.max = null;

  const mappedData: ChartDataRecord[] = [];
  data.forEach((el) => {
    const newEl: { [key: string]: number | string } = {};
    newEl[chart.maxField] = el[chart.maxField] === null ? 0 : (el[chart.maxField] as number);
    newEl[chart.medianField] = el[chart.medianField] === null ? 0 : (el[chart.medianField] as number);
    newEl[chart.minField] = el[chart.minField] === null ? 0 : (el[chart.minField] as number);
    newEl[chart.settings.decompositionMetric as string] = el[chart.settings.decompositionMetric as string] as number;

    if (chart.max === null || chart.max < newEl[chart.maxField]) {
      chart.max = newEl[chart.maxField] as number;
    }

    if (chart.min === null || chart.min > newEl[chart.minField]) {
      chart.min = newEl[chart.minField] as number;
    }

    if (newEl[chart.settings.decompositionMetric as string] === null) {
      newEl[chart.settings.decompositionMetric as string] = Lang.null as string;
    }

    mappedData.push(newEl);
  });

  data = orderBy(mappedData, chart.medianField, "desc");

  data.sort((a: ChartDataRecord, b: ChartDataRecord) => {
    return (b[chart.medianField] as number) - (a[chart.medianField] as number);
  });

  if (isReverse) {
    reverse(data);
  }

  return data;
};
